<template>
    <div class="configOwnerOptionVue">
        <div class="col-md-10 o-config-side-padd c-common-box-shadow u-bg-color-fff">
            <div class="owner-option">

                 <div class="col-md-12 o-no-padding">
                    <div class="col-md-6">
                        <h3>Admin lock <span class="c-common-btn--inverse-icon-orange"><!-- <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> --></span></h3>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Password:</label>
                                        </div>
                                        <div class="form-group-right">
                                            <input type="password" class="form-control" placeholder="Password" v-model="custom_field1">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Confirm Password:</label>
                                        </div>
                                        <div class="form-group-right">
                                            <input type="password" class="form-control" placeholder="Confirm Password" v-model="custom_field2">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-md-8">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Show on which pages:</label>
                                        </div>
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                Employee List
                                                <input type="checkbox" name="o4" value="1"  v-model="client.employee_title">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                Call Assignment
                                                <input type="checkbox" name="o4" value="1" v-model="client.call_assignment_title">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                Phone Sheet
                                                <input type="checkbox" name="o4" value="1" v-model="client.call_sheet_title">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    import service from '../../services.js';
    export default {
        data() {
            return {
                client: [],
                logo_image: "",
                login_image: "",
                custom_field1: "",
                custom_field2: "",
                skill_lock: false,
                timezones : moment.tz.names(),
                options4: [],
                value9: [],
                list: [],
                loading: false,
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: "userClientID"
            })
        },
        methods: {
            goTojobList() {
                this.$router.push({
                    'path': "/jobList"
                });
            },
            saveOptions() {
                this.client.employee_title = (this.client.employee_title == true) ? 1 : 0;
                this.client.call_sheet_title = (this.client.call_sheet_title == true) ? 1 : 0;
                this.client.call_assignment_title = (this.client.call_assignment_title == true) ? 1 : 0;


                this.client['client_id'] = this.client.id;
                var customValue = "";
                if (this.custom_field1 != this.client.custom_field_1)
                    this.client.custom_field1 = JSON.stringify({
                        name: this.custom_field1,
                        value: customValue
                    });

                if (this.custom_field2 != this.client.custom_field_2)
                    this.client.custom_field2 = JSON.stringify({
                        name: this.custom_field2,
                        value: customValue
                    });
                this.client.skill_lock = (this.skill_lock == true) ? 1 : 0;

                if (this.client.client_employees)
                //console.log('test',this.client);
                service.post('employee/ownerOptions', this.client, {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        this.$cookies.set("time_zone", this.client.timezone);
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Owner option saved Successfully.',
                            type: 'success'
                        });

                    }).catch((err) => {
                        console.log(err);
                    });

            },
            uploadImage(e, type) {
                //console.log(e);
                var input = e.target;
                var img;
                var name;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            name = input.files[0].name;
                            if (type == 'logo')
                                this.logo_image = img;
                            else
                                this.login_image = img;
                            //console.log("login"+this.login_image);
                            service.post('attachment/uploadSingleFile', {
                                    'image_file': img,
                                    'file_name': name

                                }, {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID
                                })
                                .then((res) => {
                                    if (type == 'logo')
                                        this.client.logo = res.data.result.path;
                                    else
                                        this.client.login_image = res.data.result.path;

                                }).catch((err) => {
                                    this.$notify.error({
                                        title: this.$t('error'),
                                        message: 'Image size is too big!'
                                    });
                                });


                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 500 kb'
                        });
                    }

                }
            },
            remoteMethod(query) {
              if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                  this.loading = false;
                  this.options4 = this.list.filter(item => {
                    return item.label.toLowerCase()
                      .indexOf(query.toLowerCase()) > -1;
                  });
                }, 200);
              } else {
                this.options4 = [];
              }
            }

        },
        mounted() {
          this.list = this.timezones.map(item => {
           return { value: item, label: item };
         });
        },
        created() {
            service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                })
                .then((res) => {
                    this.client = res.data.result;
                    if (this.client.logo != "") {
                        this.logo_image = this.client.logo;
                    }
                    if (this.client.login_image != "") {
                        this.login_image = this.client.login_image;
                    }
                    this.skill_lock = (this.client.skill_lock == 1) ? true : false;
                    this.custom_field1 = this.client.custom_field_1;
                    this.custom_field2 = this.client.custom_field_2;
                }).catch((err) => {
                    console.log(err);
                });

        }
    }

</script>



// WEBPACK FOOTER //
// src/components/configuration/adminLock.vue